import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "react-bootstrap";

import logo from "../../images/logo/logo-full.png";
import LogoWhite from "../../images/logo/logofull-white.png";
import bg6 from "../../images/background/bg6.jpg";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  ResetPasswordMobForm,
  ResetPasswordEmailForm,
  resetPasswordReq,
} from "src/store/reducers/auth";
import CustomInput from "src/layouts/form/CustomInput";
import LoginHeader from "src/layouts/modules/login/LoginHeader";

export default function ResetPassword() {
  const [pending, setPending] = useState(false);
  const dispatch = useAppDispatch();

  const forgotPasswordData = useAppSelector(
    (state) => state.auth.forgot_password
  );

  const navigate = useNavigate();

  const reset = async (
    values: ResetPasswordMobForm | ResetPasswordEmailForm
  ) => {
    try {
      setPending(true);
      await dispatch(resetPasswordReq(values)).unwrap();
      toast.success("Password set successfully. Please login now.");
      navigate("/login");
    } catch (error: any) {
      toast.error(error.message || "Failed");
    } finally {
      setPending(false);
    }
  };

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: {
      otp: "",
      password: "",
      passwordRetype: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Otp is required"),
      password: Yup.string()
        .min(6, "Password is too short - should be 6 chars minimum.")
        .max(30, "Must be 30 characters or less")
        .matches(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/,
          "Please create a stronger password."
        )
        .required("Required"),
      passwordRetype: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Required"),
    }),
    onSubmit: (values) => {
      reset({ ...values, ...forgotPasswordData });
    },
  });

  if (typeof forgotPasswordData == "undefined") {
    navigate("/login");
  }

  return (
    <div className="page-wraper">
      <div className="browse-job login-style3">
        <div
          className="bg-img-fix overflow-hidden"
          style={{ background: "#fff url(" + bg6 + ")", height: "100vh" }}
        >
          <div className="row gx-0">
            <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 vh-100 bg-white ">
              <div
                id="mCSB_1"
                className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                style={{ maxHeight: "653px" }}
              >
                <div
                  id="mCSB_1_container"
                  className="mCSB_container"
                  style={{
                    position: "relative",
                    top: "0",
                    left: "0",
                    // dir: "ltr",
                  }}
                >
                  <div className="login-form style-2">
                    <div className="card-body">
                      <LoginHeader />
                      <div className="nav nav-tabs border-bottom-0">
                        <div className="tab-content w-100" id="nav-tabContent">
                          <div
                            className="tab-pane fade active show"
                            id="nav-personal"
                          >
                            <h3 className="form-title m-t0">Reset Password</h3>
                            <div className="dz-separator-outer m-b5">
                              <div className="dz-separator bg-primary style-liner"></div>
                            </div>
                            <p>
                              Enter your OTP and new password to complete
                              password reset.{" "}
                            </p>
                            <form
                              onSubmit={handleSubmit}
                              // className=" dz-form pb-3"
                            >
                              <CustomInput
                                id="otp"
                                placeholder="OTP"
                                handleChange={handleChange}
                                value={values.otp}
                                touched={touched.otp}
                                errors={errors.otp}
                              />
                              <CustomInput
                                id="password"
                                placeholder="Password"
                                inputType="password"
                                handleChange={handleChange}
                                value={values.password}
                                touched={touched.password}
                                errors={errors.password}
                              />
                              <CustomInput
                                id="passwordRetype"
                                placeholder="Retype password"
                                inputType="password"
                                handleChange={handleChange}
                                value={values.passwordRetype}
                                touched={touched.passwordRetype}
                                errors={errors.passwordRetype}
                              />

                              <div className="form-group text-left mb-5 ">
                                <Button
                                  type="submit"
                                  disabled={pending}
                                  // style={{ width: "100%" }}
                                  className="dz-xs-flex m-r5 "
                                >
                                  {pending ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    </>
                                  ) : (
                                    "Submit"
                                  )}
                                </Button>
                              </div>
                            </form>

                            <div className="text-center bottom p-1">
                              <NavLink
                                to="/login"
                                className="btn btn-primary button-md btn-block"
                              >
                                Login
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="card-footer">
                      <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                        <div className="col-lg-12 text-center">
                          <span>
                            {" "}
                            © Copyright by{" "}
                            <span
                              className={`heart ${
                                heartActive ? "" : "heart-blast"
                              }`}
                              onClick={() => setHeartActive(!heartActive)}
                            ></span>
                            <a
                              href="https://www.dexignzone.com/"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              DexignZone{" "}
                            </a>{" "}
                            All rights reserved.
                          </span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
